import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockType } from '../../../../../config/api/models/Block';
import { Icons } from '../../../../shared/components';
import AddBlockButtonLarge from './AddBlockButtonLarge';
import { AddBlockButtonProps } from '../../../types';
import AddBlockButton from './AddBlockButton';
import { useAppDispatch } from '../../../../shared/hooks/useAppDispatch';
import { addBlock } from '../../../../shared/slices/blocks/api/blocks';

const AddColumnBlockButton: FC<AddBlockButtonProps> = ({
  bookId,
  pageId,
  viewMode,
  previousBlockId,
  clusterId,
  sectionId,
}) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(
      addBlock({
        bookId,
        pageId,
        payload: {
          type: BlockType.COLUMN,
          title: t(`trajectory.page.blocks.column.title`),
          amountOfColumns: 2,
          previous_block_id: sectionId === previousBlockId ? '' : previousBlockId,
          cluster_id: clusterId,
          section_id: sectionId,
        },
      })
    );
  };

  return (
    <>
      {
        {
          emptyPage: (
            <AddBlockButtonLarge
              title={t(`trajectory.page.blocks.column.title`)}
              description={t(`trajectory.page.blocks.column.description`)}
              icon={Icons.COLUMN}
              onClick={handleClick}
            />
          ),
          sidebar: (
            <AddBlockButton viewBox="0 0 512 512" type={BlockType.COLUMN} onClick={handleClick} />
          ),
        }[viewMode]
      }
    </>
  );
};

export default AddColumnBlockButton;
